import permissions from "../../data/permissions";

export default [
    {
        name: "stockOnHandItem",
        path: "stock-on-hand-item",
        component: () => import("./../../views/warehouse/StockOnHandItemReportView.vue")
    },
    {
        name: "stockOnHandWarehouse",
        path: "stock-on-hand-warehouse",
        component: () => import("./../../views/warehouse/StockOnHandWarehouseReportView.vue"),
        meta: {
            permission: permissions.stock_on_hand_by_warehouse.read
        }
    },
    {
        name: "stockMovement",
        path: "stock-movement",
        component: () => import("./../../views/warehouse/StockMovementReportView.vue")
    },
    {
        path: "stock-issued-summary",
        component: () => import("./../../views/warehouse/StockIssuedSummaryReportView.vue")
    },
    {
        path: "stock-received-summary",
        component: () => import("./../../views/warehouse/StockReceivedSummaryReportView.vue")
    },
    {
        path: "stock-issued-by-dimension",
        component: () => import("./../../views/warehouse/DimensionIssuedItemsView.vue")
    }
]